// extracted by mini-css-extract-plugin
module.exports = {"card":"home_card__19grR"};